<!--
    作者：luoyiming
    时间：2020-04-20
    描述：修改价格
-->
<template>
    <div>
        <el-dialog title="分配商户" :visible.sync="dialogVisiblefpsh" @close="dialogFormVisible1" width="40%">
            <el-select v-model="supplierdata" placeholder="请选择">
                <el-option v-for="item in shlist" :key="item.shop_supplier_id" :label="item.name" :value="item.shop_supplier_id">
                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisiblefpsh = false">取 消</el-button>
                <el-button type="primary" @click="shchange()" :loading="loading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js';
import OrderApi from '@/api/order.js';
export default {
    data() {
        return {
            loading: false,
            dialogVisiblefpsh: true,
            shlist:[],
            supplierdata:""
        };
    },
    props: ['order_id'],
    created() {
        this.getSupplierList();
    },
    methods: {
        shchange(){
            let self = this;
            OrderApi.setSupplier({
                order_id: self.order_id,
                supplier: self.supplierdata,
            }, true).then(data => {
                self.loading = false;
                self.$message({
                    message: '操作成功',
                    type: 'success'
                });
                self.dialogVisiblefpsh = false;
            }).catch(error => {
                self.loading = false;
            });
        },
        // 获取数据
        getSupplierList() {
            SupplierApi.supplierList({}, true)
                .then(res => { 
                    this.shlist = res.data.list.data;
                    console.log("data", this.shlist);
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                });

        },
         /*关闭弹窗*/
         dialogFormVisible1() {
            this.$emit('close', { openDialog: false });
        },
    }

};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/received/dialog/Merchant.vue